/**
 * True when every group in `groups` is hidden below the mobile breakpoint, so the panel has
 * nothing left to show there and must hide itself (and its heading) rather than leave an
 * empty brand-washed box on a phone.
 *
 * An empty `groups` array is deliberately not this case: a caller that passes no groups at all
 * is a different, unaddressed contract question, not the "every requirement is mobile
 * self-evident" scenario this predicate exists to detect.
 */
export function allGroupsHiddenOnMobile(
  groups: ReadonlyArray<{ hiddenOnMobile?: boolean }>,
): boolean {
  return groups.length > 0 && groups.every((group) => group.hiddenOnMobile === true);
}
